import { TypeService } from '../services/type-service';
import { CompanyDomainModel } from '../domainModels/company-domain-model';
import { MenuDomainModel } from '../domainModels/menu-domain-model';
import { SmartFiltersDomainModel } from '../domainModels/smart-filters-domain-model';
import { SyncDomainModel } from '../domainModels/sync-domain-model';
import { SmartFilterRowViewModel } from '../views/smart-filters/components/smart-filter-card-row/smart-filter-row-view-model';
import { CustomersViewModel } from '../views/customers/customers-view-model';
import { BrandsViewModel } from '../views/products/components/brands/brands-view-model';
import { ProductAPI } from '../api/product-api';
import { BudBotDomainModel } from '../domainModels/bud-bot-domain-model';
import { BudBotAPI } from '../api/bud-bot-api';
import { WebSocketService } from '../services/web-socket.service';
import { AutomationAPI } from '../api/automation-api';
import { TagDomainModel } from '../domainModels/tag-domain-model';
import { BadgeMappingDomainModel } from '../domainModels/badge-mapping-domain-model';
import { ProductGroupDomainModel } from '../domainModels/product-group-domain-model';
import { ProductDomainModel } from '../domainModels/product-domain-model';
import { DisplayAttributeGroupsDomainModel } from '../domainModels/display-attribute-groups-domain-model';
import { AssetGroupDomainModel } from '../domainModels/asset-group-domain-model';
import { BrandDomainModel } from '../domainModels/brand-domain-model';
import { MediaManagerDomainModel } from '../domainModels/media-manager/media-manager-domain-model';
import { MediaManagerAssetService } from '../domainModels/media-manager/asset/media-manager-asset.service';
import { MediaManagerBulkDeleteService } from '../domainModels/media-manager/bulk-delete/media-manager-bulk-delete.service';
import { MediaManagerFolderService } from '../domainModels/media-manager/folder/media-manager-folder.service';
import { MediaManagerRemoteAssetSyncService } from '../domainModels/media-manager/sync/media-manager-remote-asset-sync.service';
import { MediaManagerRemoteFolderSyncService } from '../domainModels/media-manager/sync/media-manager-remote-folder-sync.service';
import { MediaManagerStore } from '../domainModels/media-manager/store';
import { MediaManagerUploadService } from '../domainModels/media-manager/upload/media-manager-upload.service';
import { CompanyRepository } from '../repositories/company/company-repository';
import { DisplayRepository } from '../repositories/display/display-repository';
import { SmartFiltersRepository } from '../repositories/smart-filters/smart-filters-repository';
import { HighGuideFiltersRepository } from '../repositories/high-guide-filters/high-guide-filters-repository';
import { TemplateRepository } from '../repositories/template/template-repository';
import { AssetRepository } from '../repositories/asset/asset-repository';
import { BudBotRepository } from '../repositories/bud-bot/bud-bot-repository';
import { UtilsRepository } from '../repositories/utils/utils-repository';
import { BadgeRepository } from '../repositories/badge/badge-repository';
import { BadgeMappingRepository } from '../repositories/badge-mapping/badge-mapping-repository';
import { BrandRepository } from '../repositories/brand/brand-repository';
import { DisplayAttributeGroupsRepository } from '../repositories/display-attribute-groups/display-attribute-groups-repository';
import { AssetGroupRepository } from '../repositories/asset-group/asset-group-repository';
import { ProductTagRepository } from '../repositories/product-tag/product-tag-repository';
import { SyncRepository } from '../repositories/sync/sync-repository';
import { ProductRepository } from '../repositories/product/product-repository';

export const apisGloballyScopedToLoginContext = [BudBotAPI, ProductAPI, AutomationAPI];

/**
 * Repositories sit between the domain models and the `*API` classes they read from. Domain models reach data through a
 * repository rather than touching the API classes directly.
 */
export const repositoriesGloballyScopedToLoginContext = [
  AssetGroupRepository,
  AssetRepository,
  BadgeMappingRepository,
  BadgeRepository,
  BrandRepository,
  BudBotRepository,
  CompanyRepository,
  DisplayAttributeGroupsRepository,
  DisplayRepository,
  HighGuideFiltersRepository,
  ProductRepository,
  ProductTagRepository,
  SmartFiltersRepository,
  SyncRepository,
  TemplateRepository,
  UtilsRepository
];

export const domainModelsGloballyScopedToLoginContext = [
  BudBotDomainModel,
  CompanyDomainModel,
  MenuDomainModel,
  BrandDomainModel,
  AssetGroupDomainModel,
  DisplayAttributeGroupsDomainModel,
  ProductDomainModel,
  ProductGroupDomainModel,
  SmartFiltersDomainModel,
  SyncDomainModel,
  TagDomainModel,
  BadgeMappingDomainModel,
  MediaManagerStore,
  MediaManagerRemoteAssetSyncService,
  MediaManagerRemoteFolderSyncService,
  MediaManagerUploadService,
  MediaManagerFolderService,
  MediaManagerAssetService,
  MediaManagerBulkDeleteService,
  MediaManagerDomainModel
];

export const viewModelsGloballyScopedToLoginContext = [BrandsViewModel, CustomersViewModel, SmartFilterRowViewModel];

export const servicesGloballyScopedToLoginContext = [TypeService, WebSocketService];
